import { each, findIndex, forEach, get, isEmpty, isNaN, uniqBy } from "lodash";
import moment from "moment";
import {
  dateToFormat, getDay, getSecondsDiff, now, secondsToTime
} from "./date";

export const getTimeString = (seconds) => {
  let time = "";
  seconds = Number(seconds)
  if (seconds === 0) return "00:00";

  let hour = parseInt(seconds / 3600);
  // 분 소숫점 올림 (1초라도 지각하면 1분 지각)
  let min = parseInt(Math.ceil((seconds % 3600) / 60));

  if (min === 60) {
    min = 0;
    hour += 1;
  }

  if (hour < 0) hour = -hour;
  if (min < 0) min = -min;

  if (hour.toString().length === 1) hour = "0" + hour;
  if (min.toString().length === 1) min = "0" + min;

  if (!isNaN(hour) || !isNaN(min)) {
    time = hour + ":" + min;
  }

  return time;
};

export const calcRangeDifference = (startDate, endDate) => {
  // 시작과 끝의 시간 차이를 초로 나타냄
  const start = moment(startDate);
  const end = moment(endDate);
  const duration = moment.duration(end.diff(start));
  const diffSecond = duration.asSeconds();

  return diffSecond;
};

export const getString24HourFormat = (date) => {
  let time = "";
  const d = new Date(date);
  let seconds = d.getSeconds();
  let min = seconds > 0 ? d.getMinutes() + 1 : d.getMinutes();
  let hour = min === 60 ? d.getHours() + 1 : d.getHours();
  if (min === 60) {
    min = 0;
  }

  if (min.toString().length === 1) min = "0" + min;

  if (!isNaN(hour) || !isNaN(min)) {
    time = hour + ":" + min;
  }

  return time;
};

export const convertSecondToString = (
  _seconds,
  isSeconds
) => {
  let {
    hours,
    minutes,
    seconds,
  } = secondsToTime(_seconds)
  if (!isSeconds) {
    if (seconds > 0) minutes++
    if (seconds < 0) minutes--
    if (minutes >= 60) hours++
    if (minutes < 0) hours--
  }
  return `
  ${_seconds < 0 ? '-' : ''}${Math.abs(hours)}시간
  ${minutes !== 0 ? `${Math.abs(minutes)}분` : ''}
  ${isSeconds && seconds !== 0 ? `${Math.abs(seconds)}초` : ''}
  `
};

// 나의 출퇴근 기록
export const getWorkScheduleEvent = (data) => {
  let transData = [];
  // 근무 기록 날짜.
  const historyDates = [];
  const { workHistoryList, workScheduleList, holidayList } = data;

  forEach(holidayList, (holiday) => {
    transData.push({
      title: holiday.title,
      start: new Date(holiday.date),
      className: "vacation",
    });
  })

  forEach(workHistoryList, (history) => {


    historyDates.push(history.workDate);
    if (history.dayType === 'workday' && history.workPlanTimeInSeconds > 0) {
      // 과거 근무예정
      if (isEmpty(history.otherWork)) {
        transData.push({
          title: `${moment(history.workStartTime).format("HH:mm")} - ${moment(
            history.workEndTime
          ).format("HH:mm")
            } `,
          start: new Date(history.workDate),
          className: "pastSchedule",
        });
      }

      if (history.isLate || history.isEarlyLeft) {
        if (isEmpty(history.commuteEndTime)) {
          // 지각 조퇴이자, 퇴근 미입력
          transData.push({
            title: `${dateToFormat(
              history.commuteStartTime,
              "HH:mm"
            )
              } - 미입력`,
            start: new Date(history.workDate),
            className: "late",
            isCommuteError: true,
            isLate: history.isLate,
            isEarlyLeft: history.isEarlyLeft,
          });
        } else {
          // 지각 혹은 조퇴
          transData.push({
            title: `${dateToFormat(
              history.commuteStartTime,
              "HH:mm"
            )
              } - ${dateToFormat(history.commuteEndTime, "HH:mm")} `,
            start: new Date(history.workDate),
            className: "late",
            isLate: history.isLate,
            isEarlyLeft: history.isEarlyLeft,
          });
        }
      } else if (history.isAbsence && isEmpty(history.otherWork)) {
        // 결근
        transData.push({
          title: "결근",
          start: new Date(history.workDate),
          className: "absence",
          isAbsence: history.isAbsence,
        });
      } else if (!isEmpty(history.commuteStartTime) && isEmpty(history.commuteEndTime)) {
        // 퇴근 미입력
        if (isEmpty(history.extendWork)) {
          // 연장근무가 없을 경우
          if (getSecondsDiff(now(), history.workEndTime) > 0) {
            // 현재시간이 퇴근시간보다 미래일 경우
            transData.push({
              title: `${dateToFormat(history.commuteStartTime, "HH:mm")} - 미입력`,
              start: new Date(history.workDate),
              className: "commuteError",
              isCommuteError: true,
            });
          } else {
            // 현재 시간이 퇴근시간보다 과거일 경우
            transData.push({
              title: `${dateToFormat(history.commuteStartTime, "HH:mm")} - 근무중`,
              start: new Date(history.workDate),
              className: "color-main-100",
              isCommuteError: true,
            });
          }
        } else {
          // 연장근무가 있을 경우
          const sortExtendWork = history.extendWork.sort((a, b) => {
            return Number(new Date(b.workEndTime)) - Number(new Date(a.workEndTime))
          })

          const workEnd = sortExtendWork[0].workEndTime
          if (getSecondsDiff(now(), workEnd) > 0) {
            // 현재시간이 퇴근시간보다 미래일 경우
            transData.push({
              title: `${dateToFormat(history.commuteStartTime, "HH:mm")} - 미입력`,
              start: new Date(history.workDate),
              className: "commuteError",
              isCommuteError: true,
            });
          } else {
            // 현재 시간이 퇴근시간보다 과거일 경우
            transData.push({
              title: `${dateToFormat(history.commuteStartTime, "HH:mm")} - 근무중`,
              start: new Date(history.workDate),
              className: "color-main-100",
              isCommuteError: true,
            });
          }
        }
      } else if (history.commuteStartTime && history.commuteEndTime) {
        //근무 완료
        transData.push({
          title: `${dateToFormat(
            history.commuteStartTime,
            "HH:mm"
          )
            } - ${dateToFormat(history.commuteEndTime, "HH:mm")} `,
          start: new Date(history.workDate),
          className: "done",
        });
      }
    } else if (history.dayType === "holiday") {
      // 근무 예정이 없으나, 출퇴근 기록이 있을 경우
      if (!isEmpty(history.commuteStartTime) && !isEmpty(history.commuteEndTime)) {
        transData.push({
          title: `${dateToFormat(history.commuteStartTime, "HH:mm")} - ${dateToFormat(history.commuteEndTime, "HH:mm") || "미입력"
            } `,
          start: new Date(history.workDate),
          className: "emptySceduleCommute",
        });
      }
      if (!isEmpty(history.commuteStartTime) && isEmpty(history.commuteEndTime)) {
        // 퇴근 미입력
        transData.push({
          title: `${dateToFormat(history.commuteStartTime, "HH:mm")} - 미입력`,
          start: new Date(history.workDate),
          className: "emptySceduleCommute",
        });
      }
    }

    // 휴가
    if (!isEmpty(history.vacations)) {
      forEach(history.vacations, ({ date, vacationDayType }) => {
        if (vacationDayType !== "none") {
          transData.push({
            title: vacationDayType === "all" ? "휴가" : vacationDayType === "half" ? "반차" : "반반차",
            start: new Date(date),
            className: "vacation",
            isVacation: true,
          });
        }
      });
    }

    // 연장근무
    if (!isEmpty(history.extendWork)) {
      forEach(history.extendWork, (work) => {
        transData.push({
          title: `${dateToFormat(work.workStartTime, "HH:mm")} - ${dateToFormat(
            work.workEndTime,
            "HH:mm"
          )
            } `,
          start: new Date(history.workDate),
          className: "overtime",
        });
      });
    }

    // 특별근무
    if (!isEmpty(history.otherWork)) {
      forEach(history.otherWork, (work) => {
        transData.push({
          title: `${dateToFormat(work.workStartTime, "HH:mm")} - ${dateToFormat(
            work.workEndTime,
            "HH:mm"
          )
            } `,
          start: new Date(history.workDate),
          className: "special",
        });
      });
    }

  });

  // 근무 예정 데이터
  const scheduleList = workScheduleList.filter(
    (s) => !historyDates.includes(s.date)
  );

  forEach(scheduleList, (schedule) => {
    if (schedule.dayType === "workday" && schedule.workPlanTimeInSeconds > 0) {
      transData.push({
        title: `${dateToFormat(
          schedule.workStartTime,
          "HH:mm"
        )
          } - ${dateToFormat(schedule.workEndTime, "HH:mm")} `,
        start: new Date(schedule.date),
        className: "schedule",
      });
    }
  });

  return transData;
};

// 전체 부재자 목록
export const getAllAbsenteeList = (commuteList, employees, targetDay = getDay()) => {
  const getEmployee = (idx) => {
    return employees.find(e => e.idx === idx)
  }

  // 근무 기록
  const workHistory = get(commuteList, 'workHistoryList', [])
  // 근무 스케줄
  const workScheduleList = get(commuteList, 'workScheduleList', [])
  // 휴가 목록
  const vacationList = get(commuteList, 'vacationList', [])

  const notCommutedList = [] // 미출근자
  const tardyList = [] // 지각자
  const earlyLeftList = [] // 조퇴자
  const vacationAllList = [] // 휴가자
  const vacationHalfList = [] // 반차
  const vacationQuarterList = [] // 반반차
  const otherWorkList = [] // 기타근무
  const absenteeList = []// 결근

  each(workHistory, (work) => {
    const targetEmployeeIdx = work.employeeIdx
    // 워크 스케줄의 date와 타겟 day가 일치하면
    if (work.workDate === targetDay) {
      // 지각자 확인
      if (work.isLate) {
        tardyList.push(getEmployee(targetEmployeeIdx))
      }
      // 조퇴자 확인
      if (work.isEarlyLeft) {
        earlyLeftList.push(getEmployee(targetEmployeeIdx))
      }

      // 결근자
      if (work.isAbsence) {
        absenteeList.push(getEmployee(targetEmployeeIdx))
      }

      // 기타 근무
      if (!isEmpty(work.otherWork)) {
        otherWorkList.push(getEmployee(targetEmployeeIdx))
      }
    }
  })

  each(vacationList, (vacation) => {
    const targetEmployeeIdx = vacation.employeeIdx
    const vacationTarget = vacation.requestSchedule.find(v => v.date === targetDay)
    if (vacationTarget && vacationTarget.vacationDayType === 'all') {
      vacationAllList.push({
        ...getEmployee(targetEmployeeIdx),
        description: vacation.description,
        title: vacation.title
      })
    }
    if (vacationTarget && vacationTarget.vacationDayType === 'half') {
      vacationHalfList.push({
        ...getEmployee(targetEmployeeIdx),
        description: vacation.description,
        title: vacation.title
      })
    }
    if (vacationTarget && vacationTarget.vacationDayType === 'quarter') {
      vacationQuarterList.push({
        ...getEmployee(targetEmployeeIdx),
        description: vacation.description,
        title: vacation.title
      })
    }
  })


  // 미출근자 확인
  each(workScheduleList, (workSchedule) => {
    const targetEmployeeIdx = workSchedule.employeeIdx
    if (workSchedule.date === targetDay) {
      if (workSchedule.dayType === 'workday') {
        const target = workHistory.find(e => e.employeeIdx === targetEmployeeIdx)
        // 휴가자 및 기타 근무자 제외
        const vacationTarget = vacationList.find(e => e.employeeIdx === targetEmployeeIdx)
        const otherWorkTarget = otherWorkList.find(e => e.employeeIdx === targetEmployeeIdx)
        if (!target && !vacationTarget && !otherWorkTarget) {
          const employee = getEmployee(targetEmployeeIdx)
          notCommutedList.push(employee)
        }
      }
    }
  })



  return {
    notCommutedList,
    tardyList,
    earlyLeftList,
    vacationAllList,
    vacationHalfList,
    vacationQuarterList,
    otherWorkList,
    absenteeList,
  }
}

// 부서별 근무기록/부재자 목록
export const getPartAbsenteeList = (commuteList, requestList) => {
  let datas = []
  const workHistory = get(commuteList, 'workHistoryList', [])
  const vacationList = get(commuteList, 'vacationList', [])
  const uniqParts = uniqBy([...workHistory, ...vacationList, ...(requestList || [])], 'partIdx')
  // 휴가 목록

  forEach(uniqParts, (part, idx) => {
    datas[idx] = {
      partIdx: part.partIdx,
      absenceEmployees: [], // 결근자 목록
      vacationAllEmployees: [], // 휴가자 연차 목록
      vacationHalfEmployees: [], // 휴가자 반차 목록
      vacationQuarterEmployees: [], // 휴가자 반반차 목록
      otherWorkEmployees: [], // 기타근무자 목록
      lateEmployees: [],  // 지각자 목록
      earlyLeftEmployees: [], // 조퇴자 목록
      shortWorkTimeEmployees: [], // 근로시간 미달자 목록
      extendWorkTimeEmployees: [], // 연장근무자 목록
      holidayWorkEmployees: [], // 휴일 근무자 목록
      nightWorkEmployees: [], // 야간 근무자 목록
      requestEmployees: [] // 근무기록 수정 요청자 목록
    }
  })

  if (!isEmpty(commuteList)) {
    forEach(workHistory, (history) => {
      const dataIndex = findIndex(datas, (d) => d.partIdx === history.partIdx)

      if (history.isAbsence) {
        // 근무기록이 결근이면
        datas[dataIndex].absenceEmployees.push({
          startTime: history.commuteStartTime,
          endTime: history.commuteEndTime,
          date: history.workDate,
          employeeIdx: history.employeeIdx
        })
      }

      // if (!isEmpty(history.vacations) && some(history.vacations, ['vacationDayType', 'all'])) {
      //   // 근무기록에 휴가가 있고 vacationDayType이 all(연차)이면
      //   datas[dataIndex].vacationEmployees.push({
      //     date: history.workDate,
      //     employeeIdx: history.employeeIdx
      //   })
      // }

      if (!isEmpty(history.otherWork)) {
        // 근무기록에 기타근무 기록이 있으면
        datas[dataIndex].otherWorkEmployees.push({
          startTime: history.commuteStartTime,
          endTime: history.commuteEndTime,
          date: history.workDate,
          employeeIdx: history.employeeIdx
        })
      }

      if (history.isLate) {
        // 지각
        datas[dataIndex].lateEmployees.push({
          startTime: history.commuteStartTime,
          endTime: history.commuteEndTime,
          date: history.workDate,
          employeeIdx: history.employeeIdx
        })
      }

      if (history.isEarlyLeft) {
        // 조퇴
        datas[dataIndex].earlyLeftEmployees.push({
          startTime: history.commuteStartTime,
          endTime: history.commuteEndTime,
          date: history.workDate,
          employeeIdx: history.employeeIdx
        })
      }

      if (history.shortWorkTimeInSeconds) {
        // 근로시간 미달
        datas[dataIndex].shortWorkTimeEmployees.push({
          startTime: history.commuteStartTime,
          endTime: history.commuteEndTime,
          date: history.workDate,
          employeeIdx: history.employeeIdx
        })
      }

      if (history.extendWorkTimeInSeconds) {
        // 연장근무
        datas[dataIndex].extendWorkTimeEmployees.push({
          startTime: history.commuteStartTime,
          endTime: history.commuteEndTime,
          date: history.workDate,
          employeeIdx: history.employeeIdx
        })
      }

      if (history.nightWorkTimeInSeconds) {
        // 야간근무
        datas[dataIndex].nightWorkEmployees.push({
          startTime: history.commuteStartTime,
          endTime: history.commuteEndTime,
          date: history.workDate,
          employeeIdx: history.employeeIdx
        })
      }

      if (!isEmpty(history.holidayWork)) {
        // 연장근무
        datas[dataIndex].holidayWorkEmployees.push({
          startTime: history.commuteStartTime,
          endTime: history.commuteEndTime,
          date: history.workDate,
          employeeIdx: history.employeeIdx
        })
      }
    })
  }

  if (!isEmpty(vacationList)) {
    forEach(vacationList, (v) => {
      const dataIndex = findIndex(datas, (d) => d.partIdx === v.partIdx)

      forEach(v.requestSchedule, (s) => {
        if (s.vacationDayType === 'all') {
          datas[dataIndex].vacationAllEmployees.push({
            startTime: s.commuteStartTime,
            endTime: s.commuteEndTime,
            date: s.date,
            employeeIdx: v.employeeIdx
          })
        }
        if (s.vacationDayType === 'half') {
          datas[dataIndex].vacationHalfEmployees.push({
            startTime: s.commuteStartTime,
            endTime: s.commuteEndTime,
            date: s.workDate,
            employeeIdx: v.employeeIdx
          })
        }
        if (s.vacationDayType === 'quarter') {
          datas[dataIndex].vacationQuarterEmployees.push({
            startTime: s.commuteStartTime,
            endTime: s.commuteEndTime,
            date: s.workDate,
            employeeIdx: v.employeeIdx
          })
        }
      })
    })
  }

  if (!isEmpty(requestList)) {
    forEach(requestList, (req) => {
      const dataIndex = findIndex(datas, (d) => d.partIdx === req.partIdx)
      if (dataIndex === -1) return
      datas[dataIndex].requestEmployees.push({
        startTime: req.commuteStartTime,
        endTime: req.commuteEndTime,
        date: dateToFormat(req.createdTime),
        employeeIdx: req.employeeIdx
      })
    })
  }

  return datas
}
